import { render, staticRenderFns } from "./BadGoodsReceipt.vue?vue&type=template&id=76e4ad52&"
import script from "./BadGoodsReceipt.vue?vue&type=script&lang=js&"
export * from "./BadGoodsReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports